import React from 'react'
import AuthenticationComponent from '../../components/developerApi/developerSdk/Authentication/AuthenticationComponent'

import './authenticationLayout.scss'

class AuthenticationLayout extends React.Component {
    render() {
        return <div className="authentication-layout">
            <AuthenticationComponent />
        </div>
    }
}

export default AuthenticationLayout



// WEBPACK FOOTER //
// ./src/layouts/Authentication/AuthenticationLayout.js